import { Component, OnInit } from "@angular/core";
import { MetaService } from "../meta.service";

@Component({
	selector: "discover-difference",
	templateUrl: "./discover-difference.component.html",
	styleUrls: ["./discover-difference.component.css"],
})
export class DiscoverDifferenceComponent implements OnInit {
	//inject services
	constructor(private mds: MetaService) {}

	//initialize the component
	ngOnInit(): void {
		//SEO Optimization
	}
}
